<template>
  <v-col cols="12">
    <FormModal
      :isTheModalOpen="formModalData.isOpen"
      :modalButtonText="formModalData.buttonText"
      :modalFormTitle="formModalData.formTitle"
      :modalType="formModalData.modalType"
      :isModalButtonVisible="formModalData.isButtonsVisible"
      :isModalButtonDisabled="formModalData.isButtonsDisabled"
      v-on:formmodal-close="formModalData.isOpen = false"
    >
      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.numeroNota"
          name="numeroNota"
          label="Número nota"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.valorNota"
          name="vlTotal"
          label="Valor da nota"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.nomeEmpresa"
          name="nomeEmpresa"
          label="Nome Fantasia"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.cnpjEmpresa"
          name="nomeEmpresa"
          label="CNPJ"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <DataTable
          :tableTitle="'Produtos'"
          :tableHeader="headersModal"
          :tableRows="formModalData.actualEdit.itensNota"
        >
        </DataTable>
      </v-col>
    </FormModal>
    <DataTable
      v-show="showSkeletonTableModal == false"
      :tableTitle="'Notas'"
      :tableHeader="headers"
      :tableRows="listHistoricoEntrada"
      :isView="true"
      v-on:datatable-viewrow="visuzalizarNota"
    >
    </DataTable>
    <SkeletonTable
      v-show="showSkeletonTableModal == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import axios from "../plugins/axios";
import FormModal from "@/components/FormModal.vue";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import SkeletonTable from "../components/SkeletonTable";

export default {
  components: {
    DataTable,
    FormModal,
    Loading,
    SkeletonTable,
  },

  data: () => ({
    showSkeletonTable: true,
    showSkeletonTableModal: true,
    loading: false,
    headers: [
      {
        text: "ID",
        value: "historicoEntrada.numeroHistoricoEntrada",
      },
      {
        text: "Número nota",
        value: "historicoEntrada.descricaoNumeroNota",
      },
      {
        text: "Nome da empresa",
        value: "historicoEntrada.descricaoNomeEmpresa",
      },

      {
        text: "Valor da nota",
        value: "historicoEntrada.valorTotalNota",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersModal: [
      {
        text: "Nome do Produto",
        value: "nomeItem",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Quantidade",
        value: "quantidadeTotal",
      },
      {
        text: "Valor Unitario",
        value: "valorItemIndividual",
      },
    ],

    formModalData: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsDisabled: false,
      isButtonsVisible: false,
      actualEdit: {
        numeroNota: null,
        nomeEmpresa: null,
        cnpjEmpresa: null,
        valorNota: null,
        itensNota: [],
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    listHistoricoEntrada: [],
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      try {
        const data = await axios.get("historicoEntrada", this.config);
        this.listHistoricoEntrada = data.data;
        this.showSkeletonTableModal = false;
      } catch (error) {
        console.log(error);
      }
    },

    visuzalizarNota(value) {
      this.loading = true
      this.formModalData.isOpen = true;
      this.formModalData.isEdit = false;
      this.formModalData.formTitle = "Nota";

      this.formModalData.actualEdit.numeroNota = value.historicoEntrada.descricaoNumeroNota;
      this.formModalData.actualEdit.nomeEmpresa = value.historicoEntrada.descricaoNomeEmpresa;
      this.formModalData.actualEdit.cnpjEmpresa = value.historicoEntrada.descricaoCnpjEmpresa;
      this.formModalData.actualEdit.valorNota = value.historicoEntrada.valorTotalNota;
      this.formModalData.actualEdit.itensNota = value.listItem;
      this.loading = false
    },
  },
};
</script>

<style></style>
